import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-comparativos-historicos',
  templateUrl: './dashboard-comparativos-historicos.component.html',
  styleUrls: ['./dashboard-comparativos-historicos.component.css']
})
export class DashboardComparativosHistoricosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}